import { CompanyName } from '@/domain/models/company/company-name'
import { getEloToggleByCountry } from '@/utils/getEloToggle'

const baseName = getEloToggleByCountry() ?  'icon_consultoria_elo_' : 'icon_consultoria_'

export const companyIconName: Record<CompanyName, string> = {
  [CompanyName.Natura]: `${baseName}${CompanyName.Natura}`,
  [CompanyName.Avon]: `${baseName}${CompanyName.Avon}`,
}
